import { createPinia, PiniaVuePlugin } from 'pinia';

export const PiniaPlugin = PiniaVuePlugin;
export default createPinia();;





// WEBPACK FOOTER //
// ./src/pinia/index.js